import logo from './img/home.png'
import React, {useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import translate from './translate/header.json';
import './Header.css';
import MobileHeader from './MobileHeader';
import { logout } from '../../../shared/service';
const Header = () => {
    const navigate = useNavigate();
    const modalRef = useRef(null);
    const logOut = async () => {
      try {
        await logout();
      } catch (error) {
        console.error('Ошибка при выполнении запроса:', error);
      }
    };
    

    return (
      <div className="user-navbar" ref={modalRef}>
        <div className='left-align'>
          <button className='title-btn' onClick={() => {navigate('/')}}><img src={logo} alt="Логотип" className="user-logo" /></button>
          <button className='user-nav-btns' onClick={() => {navigate("../balance")}}> {translate.name1[JSON.parse(localStorage.getItem('choosen-language'))]}</button> 
          <button className='user-nav-btns' onClick={() => {navigate("../profile")}}> {translate.name2[JSON.parse(localStorage.getItem('choosen-language'))]}</button> 
        </div> 
        <div className='right-align'>   
          <button className='user-nav-btns logout' onClick={() => {navigate('../login'); logOut(); }}>Logout</button> 
        </div>    
        <MobileHeader logOut={logOut}/>
      </div>
    );
  };
  
  export default Header;